/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".environment[_ngcontent-%COMP%]{padding:5px;background-color:#c8102e;color:#fff!important}.logo[_ngcontent-%COMP%]{width:150px;vertical-align:middle;display:inline-block}"];
export { styles as styles };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/app.component.css.shim.ngstyle.js.pre-build-optimizer.js